<template>
	<label
		class="flex items-center justify-normal gap-2 mb-0 p-1 text-xs font-medium text-secondary cursor-pointer hover:bg-lightPrimary first-letter:uppercase md:gap-3.5 sm:text-sm"
		:class="{
			'!text-primary': props.modelValue,
			'flex-row': props.orientation === 'row',
			'flex-row-reverse': props.orientation === 'row-reverse',
		}"
	>
		<check-box
			:disabled="props.disabled"
			:model-value="props.modelValue"
			:check-variant="props.checkVariant"
			:size="props.size"
			@update:model-value="emit('update:modelValue', $event)"
		/>
		{{ label }}
	</label>
</template>

<script setup lang="ts">
type Props = {
	modelValue: boolean;
	label: string;
	checkVariant?: 'circle' | 'rectangle';
	fullyRounded?: boolean;
	disabled?: boolean;
	size?: 'sm' | 'md';
	orientation?: 'row' | 'row-reverse';
};

const props = withDefaults(defineProps<Props>(), {
	checkVariant: 'circle',
	size: 'md',
	orientation: 'row',
});

const emit = defineEmits<{
	'update:modelValue': [ newValue: boolean ];
}>();
</script>
